import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class CurrencyDefaultRateListDataService extends DataService<typeof Model.Products.Logic.ViewModels.CurrencyDefaultRateItem, Model.Products.Logic.ViewModels.CurrencyDefaultRateItem, CurrencyDefaultRateItem> {
    protected map(entity: Model.Products.Logic.ViewModels.CurrencyDefaultRateItem): CurrencyDefaultRateItem {
        return new CurrencyDefaultRateSummaryModel(entity);
    }

    public static make(context?: any): CurrencyDefaultRateListDataService {
        return new CurrencyDefaultRateListDataService(context, ctx => ctx.CurrencyDefaultRates);
    }
}

export class CurrencyDefaultRateSummaryModel extends EntityModel<Model.Products.Logic.ViewModels.CurrencyDefaultRateItem, CurrencyDefaultRateItem> implements CurrencyDefaultRateItem {

    @property<CurrencyDefaultRateSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<CurrencyDefaultRateSummaryModel>(o => o.entity.fromCurrencyId, (o, value) => o.entity.fromCurrencyId = value)
    public fromCurrencyId: number;

    @property<CurrencyDefaultRateSummaryModel>(o => o.entity.toCurrencyId, (o, value) => o.entity.toCurrencyId = value)
    public toCurrencyId: number;

    @property<CurrencyDefaultRateSummaryModel>(o => o.entity.rate, (o, value) => o.entity.rate = value)
    public rate: number;
}



// WEBPACK FOOTER //
// ./src/app/products/currency-default-rates/list/currency-default-rate-list.data.ts